module.exports = __webpack_public_path__ + "static/media/cedula-chip.4fa6b810.png";